import React from 'react';
import './FormFieldLabel.scss';

interface FormFieldLabelProps {
    htmlFor: string;
    label: string;
    required?: boolean;
    className?: string;
}

const FormFieldLabel: React.FC<FormFieldLabelProps> = ({
    htmlFor,
    label,
    required = false,
    className = '',
}) => {
    return (
        <label
            htmlFor={htmlFor}
            className={`form-field-label ${className}`.trim()}
        >
            {label}
            {required && <span className="required-asterisk">*</span>}
        </label>
    );
};

export default FormFieldLabel;
